module.exports = "/packs/images/homepage/whatson/stand_up_to_cancer_retina~90fe54873642ef16e34657d865361b3a.jpg";